var render = function render(){var _vm=this,_c=_vm._self._c;return _c('prismic-rich-text',{staticClass:"text-center text-white title",staticStyle:{"min-height":"4em"},attrs:{"field":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }